import { Component, EventEmitter, OnInit, Output, Input, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ROUTE_PATHS } from 'src/app/route-paths';

@Component({
    selector: 'app-witness-authentication',
    templateUrl: './witness-authentication.component.html',
    styleUrls: ['./witness-authentication.component.css'],
    standalone: false
})
export class WitnessAuthenticationComponent implements OnInit {
  authService = inject(AuthService);
  private router = inject(Router);

  @Input() deId=false;
  @Output() showPincodeUpdate = new EventEmitter<boolean>();
  showDialog = false;
  username!:string;
  password!:string;
  haserror!:boolean;
  useCameraLogin = false;
  isCameraLoginEnabled = false;
  msg="";


  ngOnInit(): void {
    this.isCameraLoginEnabled = environment["isCameraLoginFeatureEnabled"]||false
  }

  authenticateWitness(){
    const data = {};
    (data as any)["username"] = this.username;
    (data as any)["password"] = this.password;
    (data as any)["useCameraLogin"] = this.useCameraLogin;
    (data as any)['deId'] = this.deId;
    this.authService.loginWitness(data).subscribe({
      next: (result) => {
        this.authService.setWitnesToken(result);
        if ((data as any)['deId']){
          this.router.navigate(['/' + ROUTE_PATHS.assayManagement + '/' + (data as any)['deId'].toString()]);
        }
        else{
          this.router.navigate(['/' + ROUTE_PATHS.assayManagement + '/' + (data as any)['deId'].toString()])
        }
      },
      error: (error) => {
        this.haserror = true;
        this.msg = error.error.message;
        return;
      }
    });
  }

  handleKeyUp(e: any) {
    // if the user presses the enter key
    if(e.keyCode === 13) {
      this.authenticateWitness();
    }
  }

  showPincodeEdit(){
    this.showPincodeUpdate.emit(true)
  }

}
